// src/components/Globals/Dialog.js
// Reusable Dialog() function for dispatching modal dialogs

import { store } from '../../redux/store';
import { openModal } from '../../redux/modalSlice';

/**
 * Confirm - Opens a confirmation dialog anywhere in the app
 * @param {Object} options - Confirm options
 * @param {string} options.title - Dialog title
 * @param {string} options.message - Dialog message/body
 * @param {function} [options.okCallBack] - Function to call on OK
 * @param {function} [options.cancelCallBack] - Function to call on Cancel (optional)
 * @param {string} [options.okText] - OK button text
 * @param {string} [options.cancelText] - Cancel button text
 */
export function Confirm({ title, message, okCallBack, cancelCallBack, okText = 'OK', cancelText = 'Annuler' }) {
  Dialog({
    title,
    message,
    dialogtype: DialogType.dlgWarning,
    okCallBack,
    cancelCallBack,
    okText,
    cancelText
  });
}

// Dialog type enum
export const DialogType = Object.freeze({
  dlgInfo: 'dlgInfo',
  dlgWarning: 'dlgWarning',
  dlgError: 'dlgError',
});

/**
 * Dialog - Opens a modal dialog anywhere in the app
 * @param {string} options.title - Dialog title
 * @param {string} options.dialogtype - Dialog type: DialogType.dlgInfo, DialogType.dlgWarning, DialogType.dlgError
 * @param {string} options.message - Dialog message/body
 * @param {function} [options.okCallBack] - Function to call on OK
 * @param {function} [options.cancelCallBack] - Function to call on Cancel
 * @param {string} [options.okText] - OK button text
 * @param {string} [options.cancelText] - Cancel button text
 */
export function Dialog({ title, message, dialogtype = DialogType.dlgInfo, okCallBack, cancelCallBack, okText = 'OK', cancelText = 'Cancel' }) {
  store.dispatch(openModal({
    title,
    dialogtype,
    message,
    okCallBack,
    cancelCallBack,
    okText,
    cancelText
  }));
}
